import { render, staticRenderFns } from "./WasteVisualizationMenu.vue?vue&type=template&id=45acefee&scoped=true&"
import script from "./WasteVisualizationMenu.vue?vue&type=script&lang=js&"
export * from "./WasteVisualizationMenu.vue?vue&type=script&lang=js&"
import style0 from "./WasteVisualizationMenu.vue?vue&type=style&index=0&id=45acefee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45acefee",
  null
  
)

export default component.exports